var map = {
	"./1.jpg": 1175,
	"./2.jpg": 4178,
	"./3.jpg": 4946,
	"./4.jpg": 9379,
	"./4.png": 4748,
	"./5.jpg": 2406,
	"./5.png": 1715,
	"./6.jpg": 3673,
	"./6.png": 7738,
	"./7.jpg": 4522,
	"./7.png": 4147,
	"./author.jpg": 9469,
	"./author.png": 6859,
	"./author2.jpg": 6541,
	"./author2.png": 1561,
	"./author3.jpg": 497,
	"./author3.png": 4179,
	"./author4.jpg": 596,
	"./author4.png": 5522,
	"./author5.jpg": 4342,
	"./author5.png": 9864,
	"./link.png": 5457,
	"./post-banner1.jpg": 2277,
	"./post-banner2.jpg": 9491,
	"./post-banner3.jpg": 6270,
	"./qu.png": 9748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9773;